import { Button, Grid, IconButton, MenuItem, TextField, Tooltip } from "@material-ui/core";
import { Fragment, useEffect } from "react";
import { inputColor, inputVariant } from "../../../../settings/inputConfig";

import AddRoundedIcon from "@material-ui/icons/AddRounded";
import CuponHelper from "./CuponHelper";
import DeleteIcon from "@material-ui/icons/Delete";
import DetalleCupon from "./DetalleCupon";
import EliminarCupon from "./EliminarCupon";
import FormCupon from "./FormCupon";
import MeditocActions from "../../../utils/MeditocActions";
import MeditocBody from "../../../utils/MeditocBody";
import MeditocHeader from "../../../utils/MeditocHeader";
import MeditocTable from "../../../utils/MeditocTable";
import RefreshIcon from "@material-ui/icons/Refresh";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { fnEmpty } from "../../../../settings/preventConfig";
import { getCuponColumns } from "../../../../models/CuponModel";
import { useCatalogo } from "../../../../context/CatalogoContext";
import { useCupon } from "../../../../context/CuponContext";
import { useLogin } from "../../../../context/LoginContext";

export default function Cupon() {
    const {
        listaCupones,
        cuponSeleccionado,
        formFiltroCupon,
        handleChangeCuponSeleccionado,
        handleChangeFormFiltroForm,
        handleClickNuevoCupon,
        handleClickDetalleCupon,
        handleClickEliminarCupon,
        handleClickRefrescarDatos,
        handleClickFiltrarCupones,
    } = useCupon();
    const { entCatalogos } = useCatalogo();
    const { usuarioPermisos } = useLogin();

    const { txtTipoCupon, txtVigente } = formFiltroCupon;
    const permisos = usuarioPermisos["2"].Submodulos["4"];

    useEffect(() => {
        handleClickRefrescarDatos();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <MeditocHeader title={permisos.Nombre}>
                {permisos.Botones["1"] && ( //Crear un cupón
                    <Tooltip title={permisos.Botones["1"].Nombre} arrow>
                        <IconButton onClick={handleClickNuevoCupon}>
                            <AddRoundedIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
                {permisos.Botones["2"] && ( //Detalle de cupón
                    <Tooltip title={permisos.Botones["2"].Nombre} arrow>
                        <IconButton onClick={handleClickDetalleCupon}>
                            <VisibilityIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
                {permisos.Botones["3"] && ( //Eliminar cupón
                    <Tooltip title={permisos.Botones["3"].Nombre} arrow>
                        <IconButton onClick={handleClickEliminarCupon}>
                            <DeleteIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
                {permisos.Botones["4"] && ( //Actualizar tabla
                    <Tooltip title={permisos.Botones["4"].Nombre} arrow>
                        <IconButton onClick={handleClickRefrescarDatos}>
                            <RefreshIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
            </MeditocHeader>
            <MeditocBody>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <MeditocActions title="Filtrar cupones" />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <TextField
                            name="txtTipoCupon"
                            label={txtTipoCupon.label}
                            value={txtTipoCupon.value}
                            onChange={handleChangeFormFiltroForm}
                            variant={inputVariant}
                            color={inputColor}
                            fullWidth
                            select
                        >
                            <MenuItem value="">Todos los cupones</MenuItem>
                            {entCatalogos.catCuponCategoria.map((cupon) => (
                                <MenuItem key={cupon.fiId} value={cupon.fiId}>
                                    {cupon.fsDescripcion}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <TextField
                            name="txtVigente"
                            label={txtVigente.label}
                            value={txtVigente.value}
                            onChange={handleChangeFormFiltroForm}
                            variant={inputVariant}
                            color={inputColor}
                            fullWidth
                            select
                        >
                            <MenuItem value="">Todos los cupones</MenuItem>
                            <MenuItem value="true">Cupón activo</MenuItem>
                            <MenuItem value="false">Cupón inactivo/vencido</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={12} className="right">
                        <Button
                            variant="contained"
                            style={{ color: "#555", marginRight: 15 }}
                            onClick={handleClickRefrescarDatos}
                        >
                            Limpiar
                        </Button>
                        <Button variant="contained" color="primary" onClick={handleClickFiltrarCupones}>
                            Filtrar
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <MeditocTable
                            id="fiIdCupon"
                            data={listaCupones}
                            row={cuponSeleccionado}
                            columns={getCuponColumns()}
                            setRow={handleChangeCuponSeleccionado}
                            fnDoubleClick={permisos.Botones["2"] ? handleClickDetalleCupon : fnEmpty}
                        />
                    </Grid>
                </Grid>
            </MeditocBody>
            <CuponHelper />
            <FormCupon />
            <DetalleCupon />
            <EliminarCupon />
        </Fragment>
    );
}
